<template>
  <div class="pb-16 pt-16" style="min-height: 50vh">
    <div class="h-2"></div>
    <div class="">
      <div
        v-for="group in groups"
        v-bind:key="group.id"
        class="pl-2 mt-3 mb-4 pr-8"
      >
        <div
          class="text-smxs text-gray-700 pl-4 pb-0.5 tracking-wider font-bold"
        >
          {{ group.title }}
        </div>
        <div v-for="section in group.sections" v-bind:key="section.id">
          <div
            :class="`
              ${
                section.id === selectedSectionId
                  ? 'text-primary bg-primary-light'
                  : ' text-gray-600 '
              }
              pl-6
              pr-6
              text-smxs font-semibold py-0.5 my-0.5 cursor-pointer rounded-r-full  hover:text-primary transition`"
            @click="onSelect(group.id, section.id)"
          >
            {{ section.title }}
          </div>
          <div v-if="section.api && section.id === selectedSectionId">
            <div
              class="text-gray-600 pl-8 pr-6 text-xs font-semibold py-0.5 my-0.5 cursor-pointer rounded-r-full hover:text-primary transition"
              v-for="request in section.api.requests"
              v-bind:key="request.title"
              @click="() => clickSub(request.request.url)"
            >
              {{ request.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainSidebar",
  data: () => {},
  props: ["groups", "onSelect", "selectedSectionId"],
  mounted() {
    window.onSectionSelection = (group, section) => {
      this.onSelect(group, section, true);
    };
  },
  methods: {
    clickSub(id) {
      document.getElementById(id).scrollIntoView({
        block: "start",
      });
    },
  },
  components: {},
};
</script>
